import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { progressStepStyle } from '@/components/ui/Navigation/ProgressStep/style';
/**
 * ステップ形式の進捗表示
 */
export const ProgressStep = (props) => {
    const { activeStepIndex, className = '', items } = props;
    /**
     * ステップの位置を返す
     */
    const getStepPosition = (index) => {
        if (index === 0)
            return 'first';
        if (index === items.length - 1)
            return 'last';
        return 'between';
    };
    const style = progressStepStyle();
    return (_jsx("ul", Object.assign({ className: style.base({ class: className }) }, { children: items.map((item, index) => {
            const stepPosition = getStepPosition(index);
            return (_jsx("li", Object.assign({ "aria-current": activeStepIndex === index ? 'step' : undefined, className: style.step({ stepPosition }) }, { children: _jsx(RouterLink, Object.assign({ className: style.stepLink(), to: item.link }, { children: _jsxs("span", Object.assign({ className: style.stepInner({ stepPosition }) }, { children: [_jsx(item.icon, { color: 'current', size: 'md' }), _jsx("span", { children: item.text })] })) })) }), `ProgressStep_${index + 1}`));
        }) })));
};
